module.exports = __webpack_public_path__ + "static/media/logo.b29324c4.svg";